import { apiClient } from './api'

export interface User {
  userId: string
  username: string
  fullName: string
  email: string
  department?: string
  position?: string
  roles: string
  active: boolean
  lastLoginAt?: string
  createdAt: string
  updatedAt: string
  version: number
}

export interface UserSearchResult {
  userId: string
  userName: string
  role: string
}

export interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
}

export class UserService {
  /**
   * 軽量ユーザー検索（承認ルート定義ビルダー用）
   * GET /api/users/search?keyword=xxx
   * 最大20件、keywordが空の場合は空配列
   */
  static async search(params?: {
    keyword?: string
    limit?: number
  }): Promise<UserSearchResult[]> {
    const queryParams = new URLSearchParams()
    if (params?.keyword) queryParams.append('keyword', params.keyword)

    const queryString = queryParams.toString()
    const url = queryString ? `/api/users/search?${queryString}` : '/api/users/search'
    const response = await apiClient.get<UserSearchResult[]>(url)
    return response
  }

  static async getById(userId: string): Promise<User> {
    const response = await apiClient.get<ApiResponse<User>>(`/api/users/${userId}`)
    return response.data
  }
}
